const envDomain = "staging.cyberskiller.com";

export const environment = {
  displayedDomain: `pja.${envDomain}`,
  production: true,
  apiLocation: "/api/",
  apiDomain: `https://api.${envDomain}`,
  wsLocation: `wss://api.${envDomain}/ws/`,
  judge0ApiLocation: `https://judge.${envDomain}/`,
  captchaMocked: false,
  defaultLang: "pl",
  sentryDsn: "https://988d1134f46c44e08ba9c5907a19baa8@glitchtip.staging.cyberskiller.com/2",
  sentryEnvironment: "staging",
  sentryTracesSampleRate: 0.02,
};
